import { Directive, forwardRef, Input } from '@angular/core';
import { Validator, AbstractControl, ValidationErrors, NG_ASYNC_VALIDATORS } from '@angular/forms';
import { DataService } from '@app/core/services/data.service';
import { Observable } from 'rxjs';
import { debounceTime, first, distinctUntilChanged } from 'rxjs/operators';

@Directive({
    selector: '[pmLicenseNumberUnicityValidator][ngModel]',
    providers: [
        {
            provide: NG_ASYNC_VALIDATORS,
            useExisting: forwardRef(() => LicenseNumberUnicityValidator),
            multi: true
        }
    ],
    standalone: false
})
export class LicenseNumberUnicityValidator implements Validator {
  @Input() accountId: number;

  constructor(private dataService: DataService) {}

  validate(control: AbstractControl): ValidationErrors {
    return this.validateUniqueLicenseNumber(control.value).pipe(
      debounceTime(500),
      distinctUntilChanged(),
      first()
    );
  }


  validateUniqueLicenseNumber(licenseNumber: string) {
    return new Observable(observer => {
      this.dataService.checkLicenseNumbersUniqueness(this.accountId, licenseNumber).subscribe({
        next: resp => {
          if (resp) {
            observer.next({ alreadyExists: true });
          } else {
            observer.next(null);
          }
        },
        error: err => observer.next(null)
      });
    });
  }
}
